import { useEffect, useState, useCallback } from "react";
import { fetchPropertyByRealId } from "../state/actions/propertyActions";

export const SELECTION_STATE = {
  NONE: "none",
  ALL: "all",
  DESELECTED: "deselected",
};

export const useAddImages = ({ propertyId, dispatch }) => {
  const [showLoader, setShowLoader] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [selectionState, setSelectionState] = useState(SELECTION_STATE.NONE);

  useEffect(() => {
    if (propertyId) {
      dispatch(fetchPropertyByRealId(propertyId));
    }
  }, [propertyId, dispatch]);

  useEffect(() => {
    if (propertyId && pageLoading) {
      dispatch(fetchPropertyByRealId(propertyId)).then(() => {
        setTimeout(() => setPageLoading(false), 500);
      });
    }
  }, [propertyId, pageLoading, dispatch]);

  const toggleSelectAll = useCallback(() => {
    setSelectionState((prev) =>
      prev !== SELECTION_STATE.ALL
        ? SELECTION_STATE.ALL
        : SELECTION_STATE.DESELECTED
    );
  }, []);

  return {
    showLoader,
    setShowLoader,
    pageLoading,
    setPageLoading,
    selectionState,
    toggleSelectAll,
    isAllSelected: selectionState === SELECTION_STATE.ALL,
    isAllDeselected: selectionState === SELECTION_STATE.DESELECTED,
  };
};
